import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FieldType } from '@ngx-formly/material';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'sc-field-toggle',
  templateUrl: './field-toggle.component.html',
  styleUrls: ['./field-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldToggleComponent extends FieldType implements OnInit {
  @ViewChild(MatSlideToggle, { static: true }) slideToggle!: MatSlideToggle;
  defaultOptions = {
    templateOptions: {
      hideFieldUnderline: true,
      floatLabel: 'always',
      hideLabel: true
    }
  };

  public checked$: Observable<boolean>;

  public ngOnInit() {
    if (!this.formControl.value) {
      this.formControl.setValue('N');
    }

    this.checked$ = this.formControl.valueChanges.pipe(
      startWith(this.formControl.value || 'N'),
      map(term => term === 'Y')
    );
  }

  onContainerClick(event: MouseEvent): void {
    this.slideToggle.focus();
    this.onContainerClick(event);
  }

  public onChange(checked: boolean) {
    const value = checked ? 'Y' : 'N';
    this.formControl.setValue(value);
    this.formControl.markAsTouched();
  }
}
